import styled from "styled-components";
import { TextField, Grid } from "@material-ui/core";

export const STTextField = styled(TextField)`
  && {
    display: none;
  }
`;

export const STGrid = styled(Grid)`
  && {
    margin-top: 15px;
  }
`;

export const STPreviewImage = styled.img`
  max-width: 150px;
  max-height: 50px;
  display: block;
  margin-right: 35px;
`;

export const STButtonsGrid = styled(Grid)`
  && {
    width: fit-content;
  }
`;
